<template>
  <proa-modal
    :modal="modal"
    :title="$t('models.taskCard.period')"
    @close="$emit('close')"
  >
    <proa-input-group :label="$t('models.taskCard.attributes.startAt')">
      <template slot="input">
        <proa-input
          v-model="innerStartAt"
          type="date"
          max="2100-01-01"
          dark
          @change.native="validatePeriod"
        />
      </template>
    </proa-input-group>
    <proa-input-group :label="$t('models.taskCard.attributes.endAt')">
      <template slot="input">
        <proa-input
          v-model="innerEndAt"
          type="date"
          max="2100-01-01"
          dark
          @change.native="validatePeriod"
        />
      </template>
    </proa-input-group>
    <span v-if="invalidPeriod" class="text-error">{{ $t('models.taskCard.invalidPeriod') }}</span>
    <template slot="footer">
      <proa-button
        @click.native="$emit('close')"
        class="default-button-width mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        :disabled="invalidPeriod"
        @click.native="emitUpdatePeriod"
        class="default-button-width"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EditProjectTaskCardPeriodModal',
  props: {
    startAt: String,
    endAt: String,
    modal: Boolean
  },
  data() {
    return {
      innerStartAt: null,
      innerEndAt: null,
      invalidPeriod: false
    }
  },
  methods: {
    initPeriod: function() {
      this.invalidPeriod = false
      this.innerStartAt = this.startAt ? moment(this.startAt).format('YYYY-MM-DD') : null
      this.innerEndAt = this.endAt ? moment(this.endAt).format('YYYY-MM-DD') : null
    },
    emitUpdatePeriod: function() {
      // NOTE: null合体演算子では空文字を拾えないので三項演算子に(v-modelでbindしているため)
      this.$emit(
        'onUpdatePeriod',
        this.innerStartAt ? this.innerStartAt : null,
        this.innerEndAt ? this.innerEndAt : null
      )
    },
    validatePeriod: function() {
      this.invalidPeriod = !!this.innerStartAt &&
                           !!this.innerEndAt &&
                           moment(this.innerStartAt).isAfter(moment(this.innerEndAt))
    }
  },
  watch: {
    modal: function(value) {
      if (!value) return
      this.initPeriod()
    }
  }
}
</script>
